import LoadingOverlay from "react-loading-overlay";
import {
  EverlakeLoadingSpinner,
  EverlakeLoadingOverlayStyle,
} from "components/General/EverlakeLoading";

const EverlakeLoadingOverlay = (props) => {
  LoadingOverlay.propTypes = undefined;
  const { isLoading, loadingText, spinnerSize } = props;

  return (
    <LoadingOverlay
      active={isLoading}
      spinner={
        <EverlakeLoadingSpinner
          loadingText={loadingText}
          spinnerSize={spinnerSize}
        />
      }
      styles={EverlakeLoadingOverlayStyle}
    >
      {props.children}
    </LoadingOverlay>
  );
};

export default EverlakeLoadingOverlay;
